<template>
  <div
    class="checkbox control"
    :data-field="externalKey"
  >
    <input 
      :id="id"
      v-model="value"
      class="checkbox__input"
      type="checkbox"
    >
    <label 
      :for="id"
      class="checkbox__label"
    >
      {{ label }}
    </label>
  </div>
</template>

<script>
import uuid from 'uuid/v1';

export default {
  name: 'ControlCheckbox',
  props: {
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: uuid()
    },
    defaultValue: {
      type: Boolean,
      default: false
    },
    externalKey: {
      type: String,
      default: ''
    },
    externalHandler: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      value: Boolean(this.defaultValue)
    };
  },
  watch: {
    value(newValue) {
      this.externalHandler({ key: this.externalKey, val: newValue });
    },
    defaultValue(newValue) {
      this.value = Boolean(newValue);
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin checkbox-arrow($width, $height, $checkerSize) {
  .checkbox {
    &__input {
      & + label:before {
        width: $width;
        height: $height;
      }
    }

    &__input {
      & + label:after {
        width: $width;
        height: $height;
        background-size: $checkerSize;
      }
    }
  }
}

.checkbox {
  &__input {
    position: absolute; // take it out of document flow
    opacity: 0; // hide it

    & + label {
      position: relative;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        background-image: url('#{$icons-path}/check.svg');
        background-repeat: no-repeat;
        background-position: center;
        @include transitionBase(opacity)
      }
    }

    // Box.
    & + label:before {
      content: '';
      margin-right: 10px;
      display: inline-block;
      vertical-align: text-top;
      background: $color-white;
      border: 1px solid $color-grey;
      @include transitionBase(border-color);
    }
    
    // Disabled state label.
    &:disabled + label {
      color: #b8b8b8;
      cursor: auto;
    }

    // Disabled box.
    &:disabled + label:before {
      box-shadow: none;
      background: #ddd;
    }

    // Checkmark. Could be replaced with an image
    &:checked + label:after {
      opacity: 1;
    }

    &:checked + label:before {
      background-color: $color-yellow;
      border-color: $color-yellow;
    }

    &:hover + label:before {
      border-color: black;
    }
  }
}

@include desktop {
  @include checkbox-arrow(22px, 22px, 12px);
}

@include mobile {
  @include checkbox-arrow(32px, 32px, 18px);
}
</style>
